import React from 'react';
import { Route } from 'react-router-dom';
import { AREA_CAPABILITIES } from '../areaCapabilities';
import {
  ProjectDashboard,
  ProjectList,
  ProjectForm,
  ProjectScopeManager,
  ProjectSchedule,
  PreplotPage,
  CombinedProgressMap,
  ApprovedTenderPage,
} from '../lazyComponents';

/** Project portfolio and per-project workspace. */
export function ProjectRoutes({ withCapability }) {
  return (
    <>
      <Route path="/projects/:projectId/dashboard" element={withCapability(AREA_CAPABILITIES.projects, <ProjectDashboard />)} />
      <Route path="/projects/:projectId/scope" element={withCapability(AREA_CAPABILITIES.projects, <ProjectScopeManager />)} />
      <Route path="/projects/:projectId/tender" element={withCapability(AREA_CAPABILITIES.financeMaster, <ApprovedTenderPage />)} />
      <Route path="/projects/:projectId/schedule" element={withCapability(AREA_CAPABILITIES.projects, <ProjectSchedule />)} />
      <Route path="/projects/:projectId/preplot" element={withCapability(AREA_CAPABILITIES.projects, <PreplotPage />)} />
      <Route path="/projects/combined-progress" element={withCapability(AREA_CAPABILITIES.projects, <CombinedProgressMap />)} />
      <Route path="/projects/portfolio" element={withCapability(AREA_CAPABILITIES.projects, <ProjectList />)} />
      <Route path="/projects/edit/:projectId" element={withCapability(AREA_CAPABILITIES.projects, <ProjectForm />)} />
    </>
  );
}
